import store from 'commons/store/Store';
import apiClient from 'commons/api/client/apiClient';

export async function checkTerm({
  field,
  terms,
  sourceEntityId,
}: {
  field: string;
  terms: string | string[];
  sourceEntityId?: string;
}) {
  if (!terms) {
    return null;
  }
  const data = Array.isArray(terms) ? terms : [terms];
  if (data.length === 0) {
    return null;
  } else {
    const res = await apiClient.request({
      method: 'POST',
      url: `/api/v1/users/${store.state.user.data.id}/${sourceEntityId ? 'blockedFromPublishing' : 'matchBlockedTerms'}`,
      data: {
        sourceEntityId,
        field: field.toUpperCase(),
        terms: typeof terms === 'string' ? [terms] : terms,
      },
    });
    return res?.data;
  }
}
